import { render } from "./p-image.vue?vue&type=template&id=131324de&scoped=true"
import script from "./p-image.vue?vue&type=script&lang=js"
export * from "./p-image.vue?vue&type=script&lang=js"

import "./p-image.vue?vue&type=style&index=0&id=131324de&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131324de"],['__file',"src/components/p-image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "131324de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('131324de', __exports__)) {
    api.reload('131324de', __exports__)
  }
  
  module.hot.accept("./p-image.vue?vue&type=template&id=131324de&scoped=true", () => {
    api.rerender('131324de', render)
  })

}


export default __exports__